import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  overlayLoader: boolean;
  loading: boolean;

  on() {
    this.loading = true;
  }

  off() {
    this.loading = false;
  }

  get isLoading() {
    return this.loading;
  }

}
